import { ClubApp } from '@aaa/emember/types';

export function accountReservationLinks(clubId: ClubApp) {
  if (clubId === ClubApp.MidStates) {
    return 'https://travel.midstates.aaa.com/admin/users/consumers/itineraryForm';
  }

  return 'https://www.aaa.com/creditcard';
}
